module.exports = __webpack_public_path__ + "img/play.e4274240.png";